import React from 'react'
import { Autocomplete } from '@core/Components/Autocomplete'
import { searchStreetTypes } from '@mobi/account/Common/Address'
import { debounceWithReturn, DELAY } from '../../IdentityConfirmation/AddressQueries'

const StreetTypeAutosuggest = Autocomplete as new () => Autocomplete<string>

const getSuggestionValue = (suggestion: string) => suggestion

export const fetchSuggestedStreetTypes = debounceWithReturn(
  (inputValue: string): Promise<string[]> => {
    if (!inputValue || inputValue.length < 2) {
      return Promise.resolve<string[]>([])
    }

    return searchStreetTypes(inputValue).then(result => result.map(({ value }) => value))
  },
  DELAY
) as (inputValue: string) => Promise<string[]>

interface StreetTypeAutocompleteProps {
  id: string
  inputId?: string
  value?: string | null
  autoFocus?: boolean
  errorMessage: string | boolean
  onSelection(suggestion: string | null): void
  onBlur?(): void
}

export function StreetTypeAutocomplete({
  id,
  inputId,
  value = null,
  errorMessage,
  onSelection,
  autoFocus,
  onBlur,
}: StreetTypeAutocompleteProps) {
  return (
    <StreetTypeAutosuggest
      id={id}
      selection={value}
      inputProps={{ id: inputId, onBlur }}
      errorMessage={errorMessage}
      autoFocus={autoFocus}
      onSelection={onSelection}
      getSuggestionValue={getSuggestionValue}
      getSuggestionsForInputValue={fetchSuggestedStreetTypes}
    />
  )
}
